import React from 'react';
import PageLayout from '../../layouts/PageLayout/index';
import SplitLayout from '../../layouts/SplitLayout/index';
import FilterGuaranteedHoursPanel from './containers/FilterGuaranteedHoursPanel';
import GuaranteedHoursTable from './containers/GuaranteedHoursTable';

const GuaranteedHoursReport = (props) => {
  return (
    <PageLayout
      title="Guaranteed Hours Report"
      render={() => {
        return (
          <SplitLayout
            leftSize={2}
            leftRender={() => { return <FilterGuaranteedHoursPanel />; }}
            rightSize={10}
            rightRender={() => { return <GuaranteedHoursTable />; }}
          />
        );
      }}
    />
  );
};

export default GuaranteedHoursReport;
